<template>
    <o-form-group
        :form-state="formState"
        :label="label"
        :message="errorMessages"
        :nolabel="nolabel"
        :type="{ 'is-danger': hasError, 'has-addons': allowAdd }"
    >
        <b-input-group>
            <o-form-select
                :class="input_class"
                :disabled="_is_readonly"
                :options="the_list"
                :text-field="textField"
                :value-field="valueField"
                :sort-field="sortField"
                v-bind="$attrs"
                v-bind:value="value"
                v-on="inputListeners"
            >
                <template v-if="!$attrs.required" v-slot:first>
                    <option :value="null">{{ blankOptionText }}</option>
                </template>
            </o-form-select>

            <template slot="append-outer" />

            <b-input-group-append v-if="allowAdd && !nolabel">
                <b-button
                    :disabled="_is_readonly"
                    @click="show_add_new"
                    variant="outline"
                >
                    <table-plus-icon />
                </b-button>

                <b-modal
                    :title="addTitle"
                    hide-footer
                    ref="crud_dialog"
                    size="lg"
                    style="width: 900px"
                >
                    <o-crud-dialog
                        :store-name="storeName"
                        :title="addTitle"
                        @change="added_to_list"
                        @close="close"
                    >
                        <slot slot-scope="{ item, formState, serverErrors }">
                            <slot
                                :form-state="formState"
                                :item="item"
                                :server-errors="serverErrors"
                                name="form"
                            ></slot>
                        </slot>
                    </o-crud-dialog>
                </b-modal>
            </b-input-group-append>
        </b-input-group>
    </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../mixins/form_component_mixin";
import OFormGroup from "../OFormGroup";
import OCrudDialog from "./private/OCrudDialog";
import TablePlusIcon from "vue-material-design-icons/TablePlus";
import SelectInputMixin from "./private/SelectInputMixin";
import OFormSelect from "./private/OFormSelect";

export default {
    name: "OSelect",
    mixins: [FormComponentMixin, SelectInputMixin],
    components: { OFormSelect, TablePlusIcon, OCrudDialog, OFormGroup },
    props: {
        /* For Add New Button */
        allowAdd: { type: Boolean, default: false },
        storeName: { type: String, default: null },
        addTitle: { type: String, default: "Create New Item" },
    },
    data() {
        return {};
    },
    methods: {
        show_add_new() {
            this.$refs["crud_dialog"].show();
        },
        close() {
            this.$refs["crud_dialog"].hide();
        },

        added_to_list(new_id) {
            this.on_change(new_id);

            this.$refs["crud_dialog"].hide();
        },
        on_input(event) {
            // Ignore so ONLY on_change is catured and used for o-select
        },
    },
};
</script>

<style scoped></style>
